import React from 'react';
import { useRegisterComponent } from '../../../../orchestrator';
import { useRecaptchaContext } from '../../../../../contexts/recaptcha';
import { useAppSelector } from '../../../../../stores/redux.store';
import { WelcomeRecaptchaContainer } from './styled';

export const WelcomeRecaptcha = () => {
  useRegisterComponent(WelcomeRecaptcha.name);

  const { enabled: recaptchaEnabled, component: recaptchaComponent } = useRecaptchaContext();

  const recaptchaEnable = useAppSelector(state => state.appConfig.recaptchaEnable);
  const shouldSkipCaptcha = useAppSelector(state => state.welcome.shouldSkipCaptcha);

  const shouldShow =
    recaptchaEnable && !shouldSkipCaptcha && recaptchaEnabled && recaptchaComponent;

  if (!shouldShow) {
    return null;
  }

  return <WelcomeRecaptchaContainer>{recaptchaComponent}</WelcomeRecaptchaContainer>;
};
